/* eslint-disable no-unused-vars,arrow-body-style,max-len */

import React, { useState } from 'react'
import { Button, Modal, Spacer, Spinner, Text, View } from 'oio-react'
// import { Route, Switch, useHistory, useRouteMatch } from 'react-router-dom'
import BillingHistoryIcon from 'assets/icons/billingHistory'
import BillingCreditCardIcon from 'assets/icons/billingCreditCard'
// import gatherPlanDictionary from 'config/constants/gatherPlanDictionary'
import { settingsSiteUrl } from 'config/constants/urls'
import ActionListItemRow from 'src/components/Settings/ActionListItemRow'
import ProtoHeadingBlock from 'src/components/Settings/ProtoHeadingBlock'
import ProtoReturnBar from 'src/components/Settings/ProtoReturnBar'
import AsyncStripeProvider from 'src/components/utils/AsyncStripeProvider'
// import { useGatherBillingProfile } from 'src/graphql/hooks'
// import BillingHistory from './History'
// import BillingPaymentMethod from './PaymentMethod'
// import BillingPlans from './Plans'

// =======================================================
// Component
// =======================================================

const SettingsBilling = () => {
   // const history = useHistory()
   // const match = useRouteMatch()
   //
   // const [modalIsOpen, setModalIsOpen] = useState(true)
   // const { gatherBillingProfile: billingProfile, loading } = useGatherBillingProfile()
   //
   // const currentSubscriptionPlan = gatherPlanDictionary.find(p => (
   //    p.id === billingProfile?.gatherSubscription?.planId
   // ))

   return (
      <AsyncStripeProvider>
         <View>
            <ProtoReturnBar
               display="block[a-d] none[e-f]"
               returnLinkName="Site Settings"
               returnLinkTo={settingsSiteUrl}
            />
            <View
               display="flex"
               justifyContent="center">
               <View
                  maxWidth="100%[a-c] 600px[d-f]"
                  padding="40px 20px">
                  <View
                     width="100%"
                     display="flex"
                     flexFlow="column[a-c] row[d-f]">
                     <View paddingRight="60px[b-c] 150px[d-f]">
                        <ProtoHeadingBlock
                           title="Plan & Billing"
                           description="Manage the current subscription plan and billing settings associated with your account and this Community Site"
                        />
                     </View>
                  </View>
                  <Spacer size="3" />
                  <View
                     width="100%"
                     marginTop="24px"
                     borderRadius="6px"
                     padding="24px"
                     backgroundColor="#fff">
                     Coming Soon
                  </View>
                  {/*
                  <Spacer size="6" />
                  {loading && (
                     <View width="100%" textAlign="center" padding="60px" backgroundColor="#fff">
                        <Spinner width="30px" height="30px" color="#aaa" />
                     </View>
                  )}
                  {!loading && (
                     <>
                        <View
                           display="flex"
                           justifyContent="space-between"
                           width="100%"
                           borderRadius="6px"
                           padding="30px"
                           marginBottom="12px"
                           backgroundColor="#e6f0e7">
                           <View>
                              <Text size="0.7" weight="medium" transform="uppercase">
                                 Your Current Plan:
                              </Text>
                              <Text size="5" weight="medium">
                                 {currentSubscriptionPlan.name}
                              </Text>
                              <Text size="2" color="#666">
                                 {currentSubscriptionPlan.tagline}
                              </Text>
                           </View>
                           <View textAlign="right">
                              <Text size="2">
                                 {`$${currentSubscriptionPlan.price}.00/month (USD)`}
                              </Text>
                              <Spacer size="1" />
                              <Button
                                 linkTo={`${match.url}/plans`}
                                 size="xs"
                                 name="Change Plan"
                                 color="#54cc58"
                                 textColor="#fff"
                              />
                           </View>
                        </View>
                        <ActionListItemRow
                           name="Payment Method"
                           description={(
                              <>
                                 {!billingProfile.paymentMethod && (
                                    <div>You have not added a payment method</div>
                                 )}
                                 {billingProfile.paymentMethod && (
                                    <div>
                                       &#8226;&#8226;&#8226;&#8226;
                                       &nbsp;
                                       &#8226;&#8226;&#8226;&#8226;
                                       &nbsp;
                                       &#8226;&#8226;&#8226;&#8226;
                                       &nbsp;
                                       {billingProfile.paymentMethod.card.last4}
                                       <br />
                                       {`${billingProfile.paymentMethod.card.brand.toUpperCase()} - Expires ${billingProfile.paymentMethod.card.expiryMonth}/${billingProfile.paymentMethod.card.expiryYear}`}
                                    </div>
                                 )}
                              </>
                           )}
                           action={(
                              <Button
                                 linkTo={`${match.url}/payment-method`}
                                 width="78px"
                                 size="xs"
                                 name="Edit"
                                 color="#eee"
                                 textColor="#222"
                              />
                           )}
                           icon={(
                              <BillingCreditCardIcon
                                 width="16px"
                                 height="16px"
                                 strokeWidth="2px"
                                 color="#aaa"
                              />
                           )}
                        />
                        <ActionListItemRow
                           name="Billing History"
                           description="View all your previous billing history. Invoice statements are available for download."
                           action={(
                              <Button
                                 linkTo={`${match.url}/history`}
                                 width="78px"
                                 size="xs"
                                 name="View"
                                 color="#eee"
                                 textColor="#222"
                              />
                           )}
                           icon={(
                              <BillingHistoryIcon
                                 width="16px"
                                 height="16px"
                                 strokeWidth="2px"
                                 color="#aaa"
                              />
                           )}
                        />
                        <Switch>
                           <Route
                              path={`${match.url}/plans`}
                              render={() => (
                                 <Modal
                                    borderRadius="12px"
                                    overlayBackgroundColor="rgba(20,20,20,0.9)"
                                    width="100%[a-b] 960px[c-f]"
                                    height="100%[a-b] 600px[c-f]"
                                    onCloseComplete={() => {
                                       history.push(match.url)
                                       setModalIsOpen(true)
                                    }}
                                    onCloseTrigger={() => setModalIsOpen(false)}
                                    open={modalIsOpen}>
                                    <BillingPlans
                                       onCloseButtonClick={() => setModalIsOpen(false)}
                                    />
                                 </Modal>
                              )}
                           />
                           <Route
                              path={`${match.url}/payment-method`}
                              render={() => (
                                 <Modal
                                    borderRadius="6px"
                                    overlayBackgroundColor="rgba(20,20,20,0.9)"
                                    width="100%[a-b] 720px[c-f]"
                                    height="100%[a-b] auto[c-f]"
                                    onCloseComplete={() => {
                                       history.push(match.url)
                                       setModalIsOpen(true)
                                    }}
                                    onCloseTrigger={() => setModalIsOpen(false)}
                                    open={modalIsOpen}>
                                    <BillingPaymentMethod
                                       onCloseButtonClick={() => setModalIsOpen(false)}
                                    />
                                 </Modal>
                              )}
                           />
                           <Route
                              path={`${match.url}/history`}
                              render={() => (
                                 <Modal
                                    borderRadius="6px"
                                    overlayBackgroundColor="rgba(20,20,20,0.9)"
                                    width="100%[a-b] 780px[c] 900px[d-f]"
                                    height="100%[a-b] 90%[c-f]"
                                    onCloseComplete={() => {
                                       history.push(match.url)
                                       setModalIsOpen(true)
                                    }}
                                    onCloseTrigger={() => setModalIsOpen(false)}
                                    open={modalIsOpen}>
                                    <BillingHistory
                                       onCloseButtonClick={() => setModalIsOpen(false)}
                                    />
                                 </Modal>
                              )}
                           />
                        </Switch>
                     </>
                  )}
                  */}
               </View>
            </View>
         </View>
      </AsyncStripeProvider>
   )
}

export default SettingsBilling
